<!-- Start 404 Error -->
<div class="error-area">
    <div class="container">
        <div class="error-content">
            <img src="assets/img/404-error.jpg" alt="Image">
            <h3>Oops! Page Not Found</h3>
            <p>The page you are looking for might have been removed had its name changed or is temporarily unavailable.</p>
            <a routerLink="/" class="default-btn">Return To Home Page</a>
        </div>
    </div>
</div>
<!-- 404 Error End -->